import { NavigationClient, NavigationOptions } from '@azure/msal-browser';
import { NavigateFunction } from 'react-router-dom';

export class CustomNavigationClient extends NavigationClient {
    constructor(private history: NavigateFunction) {
        super();
    }

    async navigateInternal(url: string, options: NavigationOptions) {
        console.log(url);
        const relativePath = url.replace(window.location.origin, '');
        if (options.noHistory) {
            this.history(relativePath, { replace: true });
        } else {
            this.history(relativePath);
        }

        return false;
    }
}
